export const NetWorkError = Symbol("NetWorkError");
class retryNetwork {
  _network;
  _retry;
  constructor(network, retry = 3) {
    this._network = network;
    this._retry = retry;
  }
  async call(url, op, retry) {
    if (!retry) retry = this._retry;
    let success = false;
    let ret = NetWorkError;
    while (retry > 0) {
      try {
        const option = {
          method: op ? "POST" : "GET"
        };
        if (op) {
          option.data = op;
        }
        ret = await this._network(url, option);
        success = true;
        break;
      } catch (e) {
        console.error(e);
      }
      retry--;
    }
    return ret;
  }
}

/**
 * 封装聊天逻辑和表格的排序逻辑
 *
 * 基于 ShareDB
 */
export class ShareDBConnectionOfChatAndTable {
  _httpRequest;
  _shareDbConnection;
  _loginInfo;
  Table = {
    getTableDoc: this._getTableDoc.bind(this),
    initTable: this._initTable.bind(this),
    modifyTableNode: this._modifyTableNode.bind(this)
  };
  Chat = {
    getChatDoc: this._getChatDoc.bind(this),
    initChat: this._initChat.bind(this),
    addChat: this._addChat.bind(this),
    sendMessage: this._sendMessage.bind(this),
    recallMessage: this._recallMessage.bind(this),
    receiptMessage: this._receiptMessage.bind(this),
    acceptMessage: this._acceptMessage.bind(this),
    editMessage: this._editMessage.bind(this)
  };
  constructor(httpRequest, shareDbConnection, loginInfo) {
    this._httpRequest = new retryNetwork(httpRequest);
    this._shareDbConnection = shareDbConnection;
    this._loginInfo = loginInfo;
  }

  /**
   * 重新设置登录信息
   * @param loginInfo 登录信息
   */
  setLoginInfo(loginInfo) {
    this._loginInfo = loginInfo;
  }

  /**
   * 获取视图ShareDb文档
   * 需要订阅
   * data的类型是TableSeqData
   * @param view_id 视图ID
   */
  _getTableDoc(view_id) {
    return this._shareDbConnection?.get("testT1", `View${view_id.toLowerCase()}`);
  }

  /**
   * 初始化表格视图的顺序
   * @param node_id 视图所属的节点Id
   * @param org_id 空间Id
   * @param new_data 数据
   */
  async _initTable(node_id, org_id, new_data) {
    const ret = await this._httpRequest.call("/docapi/initTable", this._loginInfo ? {
      ...this._loginInfo,
      org_id,
      node_id,
      new_data
    } : {
      org_id,
      node_id,
      new_data
    });
    if (ret !== NetWorkError) {
      return ret;
    }
    return ret;
  }

  /**
   * 插入、移动、删除节点
   * @param node_id 视图所属的节点Id
   * @param org_id 空间Id
   * @param modify_node 数据
   */
  async _modifyTableNode(node_id, org_id, modify_node) {
    const ret = await this._httpRequest.call("/docapi/modifyTableNode", this._loginInfo ? {
      ...this._loginInfo,
      org_id,
      node_id,
      modify_node: modify_node
    } : {
      org_id,
      node_id,
      modify_node: modify_node
    });
    if (ret !== NetWorkError) {
      return ret;
    }
    return ret;
  }

  /**
   * 获取聊天ShareDb文档
   * 需要订阅
   * data的类型是ChatData
   * @param node_id node id
   */
  _getChatDoc(node_id) {
    return this._shareDbConnection?.get("testC1", `Doc${node_id.toLowerCase()}`);
  }

  /**
   * 初始化聊天
   * @param org_id
   * @param node_id
   * @private
   */
  async _initChat(org_id, node_id) {
    const ret = await this._httpRequest.call("/docapi/initChat", this._loginInfo ? {
      ...this._loginInfo,
      org_id,
      node_id
    } : {
      org_id,
      node_id
    });
    if (ret !== NetWorkError) {
      return ret;
    }
    return ret;
  }

  /**
   * 加入聊天
   * @param org_id
   * @param node_id
   * @param account_id 如果是自己加入则不用传
   * @private
   */
  async _addChat(org_id, node_id, account_id) {
    const ret = await this._httpRequest.call("/docapi/addChat", this._loginInfo ? {
      ...this._loginInfo,
      org_id,
      node_id,
      account_id
    } : {
      org_id,
      node_id,
      account_id
    });
    if (ret !== NetWorkError) {
      return ret;
    }
    return ret;
  }

  /**
   * 发送消息
   * @param org_id
   * @param node_id
   * @param message
   * @private
   */
  async _sendMessage(org_id, node_id, message) {
    const ret = await this._httpRequest.call("/docapi/sendMessage", this._loginInfo ? {
      ...this._loginInfo,
      org_id,
      node_id,
      message
    } : {
      org_id,
      node_id,
      message
    });
    if (ret !== NetWorkError) {
      return ret;
    }
    return ret;
  }

  /**
   * 撤回消息
   * @param org_id
   * @param node_id
   * @param message
   * @private
   */
  async _recallMessage(org_id, node_id, message) {
    const ret = await this._httpRequest.call("/docapi/recallMessage", this._loginInfo ? {
      ...this._loginInfo,
      org_id,
      node_id,
      message
    } : {
      org_id,
      node_id,
      message
    });
    if (ret !== NetWorkError) {
      return ret;
    }
    return ret;
  }

  /**
   * 修改消息是否需要已读回执
   * @param org_id
   * @param node_id
   * @param message
   * @param receipt
   * @private
   */
  async _receiptMessage(org_id, node_id, message, receipt) {
    const ret = await this._httpRequest.call("/docapi/receiptMessage", this._loginInfo ? {
      ...this._loginInfo,
      org_id,
      node_id,
      message,
      receipt
    } : {
      org_id,
      node_id,
      message,
      receipt
    });
    if (ret !== NetWorkError) {
      return ret;
    }
    return ret;
  }

  /**
   * 发送已读回执
   * @param org_id
   * @param node_id
   * @param message
   * @private
   */
  async _acceptMessage(org_id, node_id, message) {
    const ret = await this._httpRequest.call("/docapi/acceptMessage", this._loginInfo ? {
      ...this._loginInfo,
      org_id,
      node_id,
      message
    } : {
      org_id,
      node_id,
      message
    });
    if (ret !== NetWorkError) {
      return ret;
    }
    return ret;
  }

  /**
   * 编辑已发送的消息
   * @param org_id
   * @param node_id
   * @param message
   * @param delta
   * @private
   */
  async _editMessage(org_id, node_id, message, delta) {
    const ret = await this._httpRequest.call("/docapi/editMessage", this._loginInfo ? {
      ...this._loginInfo,
      org_id,
      node_id,
      message,
      delta
    } : {
      org_id,
      node_id,
      message,
      delta
    });
    if (ret !== NetWorkError) {
      return ret;
    }
    return ret;
  }
}